import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`Tester is an application that tests non-verbal reasoning ability. It is written using AngularJS, Express.js and Node.js and uses DocumentDB for storage (it was hosted on Microsoft's Azure platform). The source code can be found`}
      {" "}
      {` `}
      <a href="https://github.com/simonrose121/tester" target="_blank">{`here`}</a>
      {`.`}</p>
    <p>{`The application can be reused for other questions (these are loaded in using JSON). However, in it's current state it contains questions adapted from non-verbal reasoning worksheets for Y2 (6 and 7 years old) children. It was used as a pre-test for a research study on the effect of visual programming environments on young children (in which `}
      <a href="/projects/dimbot">{`Dimbot`}</a>
      {` was used for the main part of the study.)`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      